'use client';
import { useRouter } from 'next/navigation';
import { useState } from 'react';

export const JWTLogin = () => {
  // State for submission status and error
  const [error, setError] = useState('');
  const [isPending, setIsPending] = useState(false);

  const router = useRouter(); // For navigation after successful login

  const handleSubmit = async (event: any) => {
    event.preventDefault();
    setIsPending(true);
    setError('');

    const formData = new FormData(event.target);
    const data = {
      email: formData.get('email'),
      password: formData.get('password'),
    };

    try {
      const res = await fetch('/consumer/api/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      const result = await res.json();

      if (result?.error) {
        setError(result.error);
      } else if (result?.success) {
        // Redirect to the specified URL after login
        router.push(result.url);
      }
    } catch (err) {
      setError('An unexpected error occurred.');
    } finally {
      setIsPending(false);
    }
  };
  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div>
        <input
          className="w-full p-2 border rounded border-gray-300"
          autoComplete="email"
          autoFocus
          required
          placeholder="Email Address"
          name="email"
          type="email"
        />
      </div>
      <div>
        <input
          required
          className="w-full p-2 border rounded border-gray-300"
          autoComplete="current-password"
          placeholder="Password"
          name="password"
          type="password"
        />
      </div>
      {error && (
        <div className="error-message mt-3 text-sm text-red-600">{error}</div>
      )}
      <div className="mt-2">
        <button
          type="submit"
          disabled={isPending}
          className={`flex-shrink-0 text-sm border-4 py-1 px-2 rounded ${
            isPending
              ? 'bg-gray-500 border-gray-500 cursor-wait text-white'
              : 'bg-blue-500 hover:bg-blue-700 border-blue-500 hover:border-blue-700 text-white'
          }`}
        >
          {isPending ? 'Logging in...' : 'Log in'}
        </button>
      </div>
    </form>
  );
};
